// API Configuration for M2eBooks
// Production API endpoint - uses https://m2ebooks.com
let API_BASE_URL;

// If we're on m2ebooks.com domain, always use m2ebooks.com API
if (typeof window !== 'undefined' && window.location.hostname === 'm2ebooks.com') {
  API_BASE_URL = 'https://m2ebooks.com/php_backend/api';
} else if (typeof window !== 'undefined' && window.location.hostname.includes('m2ebooks')) {
  // Also handle www.m2ebooks.com or subdomains
  API_BASE_URL = `https://${window.location.hostname}/php_backend/api`;
} else {
  // Check environment variable or use default
  const envApiUrl = process.env.REACT_APP_API_URL;
  API_BASE_URL = (envApiUrl && !envApiUrl.includes('localhost') && !envApiUrl.includes('127.0.0.1'))
    ? envApiUrl
    : 'https://m2ebooks.com/php_backend/api';
}

// Build version identifier
const BUILD_VERSION = 'm2ebooks-v1.0';

// Log API configuration for debugging (only in browser)
if (typeof window !== 'undefined' && window.location) {
  console.log('M2eBooks API Configuration:', {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    API_BASE_URL: API_BASE_URL,
    BUILD_VERSION: BUILD_VERSION,
    envVar: process.env.REACT_APP_API_URL || 'not set',
    fullUrl: window.location.href
  });
  
  // Warn if API_BASE_URL contains wrong domain
  if (API_BASE_URL.includes('manhattanhanovertalent.com')) {
    console.error('⚠️ ERROR: Wrong API URL detected!');
    console.error('⚠️ API_BASE_URL:', API_BASE_URL);
    console.error('⚠️ This build is using the wrong API endpoint.');
    console.error('⚠️ Please rebuild the application with: npm run build');
    console.error('⚠️ Current hostname:', window.location.hostname);
  }
  
  // Warn if API_BASE_URL contains localhost (indicates old build)
  if (API_BASE_URL.includes('localhost') || API_BASE_URL.includes('127.0.0.1')) {
    console.error('⚠️ WARNING: Old build detected! API_BASE_URL contains localhost:', API_BASE_URL);
    console.error('⚠️ Please clear browser cache and ensure new build is deployed.');
  }
  
  // Verify correct domain is being used
  if (window.location.hostname.includes('m2ebooks') && !API_BASE_URL.includes('m2ebooks.com')) {
    console.error('⚠️ WARNING: Domain mismatch!');
    console.error('⚠️ Current domain:', window.location.hostname);
    console.error('⚠️ API URL:', API_BASE_URL);
    console.error('⚠️ API should point to m2ebooks.com');
  }
}

export default API_BASE_URL;

